<template>
  <div :class="`el-card--${variant}`" style="margin-bottom: 20px">
    <div class="page-header">
      <div class="page-header__main-content">
        <a
          v-if="linkName"
          class="el-icon-arrow-left page-header__back-link"
          @click="linkPassed"
        />
        <el-divider
          v-if="linkName"
          class="page-header__divider"
          direction="vertical"
        />
        <span class="page-header__title">{{ pageName }}</span>
      </div>
      <div class="page-header__additional-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageHeader',

  props: {
    // eslint-disable-next-line vue/require-default-prop
    pageName: {
      type: String,
    },
    // eslint-disable-next-line vue/require-default-prop
    linkName: {
      type: String,
      required: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    linkPath: {
      type: String,
      required: false,
    },
    variant: {
      type: String,
      default: 'standard',
    },
  },

  methods: {
    linkPassed() {
      return this.linkPath ? this.$router.push({name: this.linkPath}) : this.$router.back()
    },
  },
}
</script>

<style lang="sass" scoped>

</style>
